import React, { useState, useEffect } from 'react';
import { Grid, GridItem } from '@patternfly/react-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useTranslateText from '../use_translate_text';
import { PrimaryLink, PrimaryLinkRight, PrimaryPopUpLinkRight } from '../primary_link';
import './progress-indicator.scss';

const ProgressIndicator = (props) => {
  const { translateText } = useTranslateText(),
        { activeIndex, indexCount } = props,
        defaultState = {
          count: [],
        },
        [state, setState] = useState(defaultState);

  useEffect(() => {
    const count = [],
          activeItem = activeIndex - 1,
          gridCount = Math.floor(12 / indexCount);
    for (let i = 0; i < indexCount; i++) {
      count[i] = i;
    }
    setState({ count, gridCount, activeItem });
  }, []);


  const { count, gridCount, activeItem } = state,
        { children, backLink, nextLink, canDisableNextLink, nextLinkPopUp, submitLink, submitLinkClassNames, noBottom, validatedForm, hideProgBar } = props,
        nextLinkClassNames = canDisableNextLink ? 'primary-button__right--disabled' : '';


  return (
    <Grid className="progress-indicator">
      <GridItem lg={2} className="border-bottom-2 progress-indicator__title">
        <p className="f20-title w-99" hidden={hideProgBar}>{translateText('Your Progress')}</p>
      </GridItem>
      <GridItem lg={10} className="border-bottom-2">
        <Grid>
          {count.map((item, i) => {
            const isActive = activeItem === i,
                  length = count.length - 1,
                  isLastIndex = length === i,
                  isDone = activeItem > i,
                  className = `progress-indicator__index-count
                    ${isActive && 'progress-indicator__index-count-active'}
                    ${isDone && 'progress-indicator__index-count-done'}
                  `;

            return (
              <GridItem span={gridCount} className="progress-indicator__index" key={i} hidden={hideProgBar}>
                <p className={className}>
                  {isDone ?
                    <FontAwesomeIcon
                      icon="check"
                      size="1x"
                    />
                    : item + 1
                  }
                </p>
                {!isLastIndex && <p className="progress-indicator__index-line" />}
              </GridItem>
            );
          })}
        </Grid>
      </GridItem>
      {children}
      {!noBottom && <GridItem lg={12} className="border-top-2 pt-3">
        {backLink &&
          <PrimaryLink
            to={backLink}
            icon="arrow-left"
            label="Back"
          />
        }
        {nextLink &&
          <PrimaryLinkRight
            to={canDisableNextLink ? '' : nextLink}
            icon="arrow-right"
            label="Next"
            className={nextLinkClassNames}
          />
        }
        {nextLinkPopUp &&
          <PrimaryPopUpLinkRight
            isDisabled={canDisableNextLink}
            onClick={nextLinkPopUp}
            icon="arrow-right"
            label="Next"
            className={nextLinkClassNames}
          />
        }
        {submitLink &&
          <PrimaryPopUpLinkRight
            onClick={submitLink}
            icon="check-circle"
            label="Submit"
            className={submitLinkClassNames}
          />
        }
        {validatedForm &&
          <PrimaryPopUpLinkRight
            onClick={validatedForm}
            icon="arrow-right"
            label="Next"
            className={nextLinkClassNames}
          />
        }
      </GridItem>}
    </Grid>
  );
};

export default ProgressIndicator;
